import { useState } from "react";
import api from "@/lib/api";
import { MailX } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleString("pt-PT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export const EmailFailures = ({ pid, items, onDone, ro }) => {
  const [gone, setGone] = useState([]);
  const list = (items || []).filter((f) => !gone.includes(f.id));
  if (!list.length) return null;
  const resolve = async (f) => { setGone((g) => [...g, f.id]); await api.post(`/processes/${pid}/email-failures/${f.id}/resolve`); onDone(); };
  return (
    <div className="rounded-xl border border-red-200 bg-red-50 px-5 py-3 space-y-2" data-testid="email-failures">
      {list.map((f) => (
        <div key={f.id} className="flex items-start gap-3 text-sm text-red-900" data-testid={`email-failure-${f.id}`}>
          <MailX size={16} className="mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <div><b>Email não entregue a {f.to}</b> · {f.reason}</div>
            <div className="text-xs text-red-700/80 truncate">{f.subject} · {when(f.created_at)}{f.detail ? ` · ${f.detail}` : ""}</div>
          </div>
          {!ro && (
            <button onClick={() => resolve(f)} className="text-xs font-semibold underline underline-offset-2 hover:text-red-700 shrink-0" data-testid={`email-failure-resolve-${f.id}`}>
              Já corrigi
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
